export const ImpressionsID = 5;
export const ClicksID = 1;
export const CTRID = 4;
export const OverallID = 0;

export const metricsMap = [
  {
    id: ClicksID,
    value: 'ColumnName_Clicks',
    name: 'Clicks',
    // formatter: this.formatToInteger,
  },
  {
    id: ImpressionsID,
    value: 'TrendAreaChart_AxisY',
    name: 'Impressions',
    // formatter: this.formatToInteger,
  },
  {
    id: CTRID,
    value: 'ColumnName_CTR',
    name: 'CTR',
    // formatter: this.formatTo2DigitsPercent,
  },
];
